export default __webpack_public_path__ + "static/media/4.21b4891c.jpg";